module.exports = __webpack_public_path__ + "static/media/burriedBottomRail.2d69a2e6.png";